import { ColumnFiltersState } from "@tanstack/react-table"
import GenericFilterToggle from "../GenericToggle"
import { Popover, Transition } from "@headlessui/react"
import { Settings2 } from "lucide-react"
import { Fragment } from "react"
import { CLASS_NAME_DEFAULT } from "../../../../constants"

interface Props {
  shrinkFilter?: boolean
  popoverPlace?: "left" | "right"
  popoverPlaceInMobile?: "left" | "right"
  className?: string
  columnID: string
  columnFilters: ColumnFiltersState
  setColumnFilters: React.Dispatch<React.SetStateAction<ColumnFiltersState>>
}

const ActiveDeletedFilter = ({
  shrinkFilter = false,
  popoverPlace = "left",
  popoverPlaceInMobile = "left",
  className = CLASS_NAME_DEFAULT,
  columnID,
  columnFilters,
  setColumnFilters
}: Props) => {
  return (
    <div className={className}>
      <Popover as="div" className="relative z-10 inline-block text-left">
        <Popover.Button className="group inline-flex items-center justify-center appearance-none px-3 py-3.5 border border-neutral-200 rounded-md placeholder-gray-400 focus:outline-none hover:bg-primary-50 hover:border-primary-500 hover:text-primary-600 sm:text-sm">
          <Settings2
            size={16}
            className={`
                  flex-shrink-0 text-base-dark group-hover:text-primary-600
                  
                `}
            aria-hidden="true"
          />
          <span
            className={`${
              shrinkFilter ? "sr-only sm:not-sr-only ml-1 inline-block" : ""
            }`}
          >
            Filters
          </span>
        </Popover.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Popover.Panel
            className={`origin-top-right absolute ${
              popoverPlaceInMobile === "left"
                ? "left-0 right-auto"
                : "left-auto right-0"
            } ${
              popoverPlace === "left"
                ? "lg:left-0 lg:right-auto"
                : "lg:left-auto lg:right-0"
            } mt-2 bg-white rounded-md shadow-2xl p-4 ring-1 ring-black ring-opacity-5 focus:outline-none z-10`}
          >
            <h3 className="sr-only">Filter by active and deleted</h3>
            <div className="space-y-4">
              <GenericFilterToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="active"
                filterValue="1"
                label="Active"
              />
              <GenericFilterToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="disabled"
                filterValue="0"
                label="Disabled"
              />

              <GenericFilterToggle
                columnID={columnID}
                columnFilters={columnFilters}
                setColumnFilters={setColumnFilters}
                filterKey="deleted"
                filterValue="1"
                label="Deleted"
              />
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>
    </div>
  )
}

export default ActiveDeletedFilter
